<div class="container">
    <div class="state-user-label" [ngClass]="value" [ngStyle]="styleState">
        <div class="state-label">{{ resourceState | translate }}</div>
    </div>
</div>